import axios from "axios";
import { Token } from "../utils/localStorage.util";
import appConfig from "../config.js";
import { emitSessionExpired } from "../utils/sessionEvents.js";

const baseURL = appConfig.REACT_APP_HOST_API_AUTENTICACAO;
if (!baseURL || typeof baseURL !== "string" || !baseURL.startsWith("http")) {
  console.warn(
    "[api.service] REACT_APP_HOST_API_AUTENTICACAO não está definida ou é inválida no .env do app.",
    "Valor atual:",
    baseURL,
    "| Defina no .env a URL que o navegador consegue acessar (ex: http://localhost:5333 ou https://api-autenticacao.taxationmind.com.br). Reinicie o app (npm start) após alterar o .env."
  );
}

const api = axios.create({
  baseURL: baseURL || "",
});

api.interceptors.request.use(
  async (axiosConfig) => {
    const token = Token.getToken();
    if (token) {
      axiosConfig.headers.Authorization = token;
    }
    const secretKey = appConfig.REACT_APP_SECRET_KEY;
    if (secretKey) {
      axiosConfig.headers.secretKeyApi = secretKey;
    }

    if (
      !(axiosConfig.data instanceof FormData) &&
      !axiosConfig.headers["Content-Type"]
    ) {
      axiosConfig.headers["Content-Type"] = "application/json";
    }

    return axiosConfig;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    try {
      if (response == null || typeof response !== "object") return response ?? undefined;
      const data = response.data;
      return data !== undefined ? data : response;
    } catch {
      return undefined;
    }
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const url = String(error?.config?.url || "");
    if (status === 401 && url && !url.includes("/usuarios/autenticar")) {
      emitSessionExpired();
    }

    return Promise.reject(error);
  }
);

export default api;
